export const NAVIGATION_OPTIONS = [
  { name: 'Dashboard', shortcut: '/D' },
  { name: 'Reports', shortcut: '/R' },
  { name: 'Segments', shortcut: '/S' },
] as const;
